import {
	GET_ALL_USERS_SUCCESS,
	GET_ALL_USERS_FAIL,
	CREATE_USER_SUCCESS,
	UPDATE_USER_SUCCESS,
	UPDATE_USER_FAIL,
} from '../actions/index';
const initialState = {
	users: [],
	error: null,
	loading: true,
	count: null,
};
const userReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_ALL_USERS_SUCCESS:
			return {
				...state,
				users: action.payload.usersData,
				loading: false,
				error: null,
				count: action.payload.count,
			};
		case CREATE_USER_SUCCESS:
			return {
				...state,
				users: [...state.users, action.payload],
				loading: false,
				error: null,
				count: state.count !== null ? state.count + 1 : 1,
			};
		case UPDATE_USER_SUCCESS:
			return {
				...state,
				users: state.users.map((user) =>
					user.user_id === action.payload.user_id ? action.payload : user
				),
				loading: false,
				error: null,
			};
		case GET_ALL_USERS_FAIL:
		case UPDATE_USER_FAIL:
			return {
				...state,
				users: null,
				error: action.payload,
				loading: false,
			};

		default:
			return state;
	}
};

export default userReducer;
